/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Button from "../../../../components/Button";
import Modal, { ModalHeader } from "../../../../components/Modal";
import Profile from "../../../../components/Profile";
import { ControlTable } from "../../../../components/Table";
import { translation } from "../../../../utils/translator";

const ABSENTEE_TYPE = [
  { label: '연차', value: 'vacationAll' },
  { label: '반차', value: 'vacationHalf' },
  { label: '반반차', value: 'vacationQuarter' },
  { label: '결근', value: 'absence' },
  { label: '기타 근무', value: 'otherwork' },
  { label: '지각', value: "isLate" },
  { label: '조퇴', value: "isEarlyLeft" },
  { label: '근로 시간 미달', value: "shortWork" },
  { label: '연장 근무', value: "extendWork" },
  { label: '휴일 근무', value: "holidayWork" },
  { label: '변경 요청', value: "request" },
]

const AbsenteeModal = ({ open, setOpen, data, partList }) => {
  const { employees } = useSelector(
    (store) => ({
      employees: store.Data.employees,
    }),
  );
  const [fields, setFields] = useState([])
  const [list, setList] = useState([])

  useEffect(() => {
    setFields([
      {
        title: '이름', key: 'employeeIdx', onValue: (value) => {
          return (
            <Profile employeeIdx={value} />
          )
        }
      },
      { title: '날짜', key: 'date', type: 'date' },
      ...(data.isHideTime ? [] : [
        { title: '출근시간', key: 'startTime', type: 'time' },
        { title: '퇴근시간', key: 'endTime', type: 'time' },
      ])
    ])
  }, [employees, open])

  useEffect(() => {

    //console.log(data);
    switch (data.type) {
      case 'vacationAll':
        setList(data.vacationAllEmployees)
        break;
      case 'vacationHalf':
        setList(data.vacationHalfEmployees)
        break;
        case 'vacationQuarter':
        setList(data.vacationQuarterEmployees)
        break;
      case 'absence':
        setList(data.absenceEmployees)
        break;
      case 'otherwork':
        setList(data.otherWorkEmployees)
        break;
      case 'isLate':
        setList(data.lateEmployees)
        break;
      case 'isEarlyLeft':
        setList(data.earlyLeftEmployees)
        break;
      case 'shortWork':
        setList(data.shortWorkTimeEmployees)
        break;
      case 'extendWork':
        setList(data.extendWorkTimeEmployees)
        break;
      case 'holidayWork':
        setList(data.holidayWorkEmployees)
        break;
      case 'request':
        setList(data.requestEmployees)
        break;
      case 'late':
        setList(data.lateEmployees)
        break;
      case 'earlyLeft':
        setList(data.earlyLeftEmployees)
        break;
      default:
        break;
    }
  }, [open, data])

  const cancel = () => {
    setOpen(false)
  }

  return (
    <Modal size="md" isOpen={open} close={cancel}>
      <div className="absentee-info-modal">
        <ModalHeader>{translation(partList, data.partIdx, "idx", "partName")}
          <span className="sub-title">{translation(ABSENTEE_TYPE, data.type)}</span>
        </ModalHeader>
        <ControlTable
          fields={fields}
          list={list}
        />
        <Button className="close-button" label="닫기" action={cancel} />
      </div>
    </Modal>
  );
};

export default AbsenteeModal;